export const SpinLoyErrorCodes = {
  ORGANIZATION_HAS_NO_LICENSE: 10,
  ORGANIZATION_NOT_FOUND: 11,
  ORGANIZATION_DOES_NOT_MATCH_CUSTOMERS_ORGANIZATION: 20,
  ORGANIZATION_DOES_NOT_MATCH_PAYMENT_ORGANIZATION: 21,
  PAYMENT_DOES_NOT_EXIST: 22,
  USER_NOT_FOUND: 30,
  INVALID_CONFIRMATION_TOKEN: 90,
  CUSTOMER_HAS_ACTIVE_SUBSCRIPTIONS: 103
};
